import axios from 'axios';
import { API_CONFIG, getHeaders } from './config';

const client = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: getHeaders(),
});

export interface Contact {
  id?: number;
  name: string;
  email: string;
  subject: string;
  message: string;
  createdAt?: Date;
}

export const contactApi = {
  async submitContact(contact: Contact): Promise<void> {
    await client.post('/contact', contact);
  },
};